export const MONTHS = [
  { value: '01', label: 'Январь' },
  { value: '02', label: 'Февраль' },
  { value: '03', label: 'Март' },
  { value: '04', label: 'Апрель' },
  { value: '05', label: 'Май' },
  { value: '06', label: 'Июнь' },
  { value: '07', label: 'Июль' },
  { value: '08', label: 'Август' },
  { value: '09', label: 'Сентябрь' },
  { value: '10', label: 'Октябрь' },
  { value: '11', label: 'Ноябрь' },
  { value: '12', label: 'Декабрь' },
];

export const DAYS = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));

// Games never need a year typed in directly — it's always the season's start year.
// Removes the one input that caused mis-sorted games (a dropped year digit).
export function buildGameDate(year: string, month: string, day: string): string {
  return `${year}-${month}-${day}`;
}

export function splitGameDate(isoDate: string): { day: string; month: string } {
  const [, month, day] = isoDate.split('-');
  return { month: month ?? '', day: day ?? '' };
}

// Queensland observes no DST — AEST is always UTC+10.
const BRISBANE_OFFSET_MS = 10 * 60 * 60 * 1000;

// Games are Saturday evenings (Brisbane time). When opening the "add results"
// form, default to the most recently completed Saturday — today if it's
// Saturday, otherwise the most recent past Saturday — so the admin usually
// doesn't need to touch the day/month pickers at all.
export function getDefaultGameDayMonth(): { day: string; month: string } {
  const brisbaneMs = Date.now() + BRISBANE_OFFSET_MS;
  const dayOfWeek = new Date(brisbaneMs).getUTCDay(); // 0=Sun … 6=Sat
  const daysSinceSat = (dayOfWeek - 6 + 7) % 7;
  const lastSaturday = new Date(brisbaneMs - daysSinceSat * 24 * 60 * 60 * 1000);
  return {
    day: String(lastSaturday.getUTCDate()).padStart(2, '0'),
    month: String(lastSaturday.getUTCMonth() + 1).padStart(2, '0'),
  };
}
